/*
 * @Description: mutation-types
 * @Date: 2021-10-28 19:08:05
 * @LastEditTime: 2021-11-08 20:07:24
 */
// 设置sdkAppId, userSig等信息
export const SET_APP_INFO = 'SET_APP_INFO';
// 更新房间阶段
export const UPDATE_LIVE_STAGE = 'UPDATE_LIVE_STAGE';
// 设置房间ID
export const SET_ROOM_ID = 'SET_ROOM_ID';
// 更新房间信息
export const UPDATE_ROOM_NAME = 'UPDATE_ROOM_NAME';
// 更新用户信息
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
// 更新屏幕分享状态 (开始 ｜ 暂停)
export const UPDATE_IS_SCREEN_SHARING = 'UPDATE_IS_SCREEN_SHARING';
// 更新使用的摄像头设备
export const UPDATE_ACTIVE_CAMERA = 'UPDATE_ACTIVE_CAMERA';
// 更新使用的麦克风设备
export const UPDATE_ACTIVE_MICROPHONE = 'UPDATE_ACTIVE_MICROPHONE';
// 更新使用的扬声器设备
export const UPDATE_ACTIVE_SPEAKER = 'UPDATE_ACTIVE_SPEAKER';
// 更新是否设置本地流镜像
export const UPDATE_SET_MIRROR = 'UPDATE_SET_MIRROR';
// 更新视频Profile
export const UPDATE_VIDEO_PROFILE = 'UPDATE_VIDEO_PROFILE';
// 更新是否开启美颜
export const UPDATE_OPEN_BEAUTY = 'UPDATE_OPEN_BEAUTY';
// 更新美颜参数
export const UPDATE_BEAUTY_PARAM = 'UPDATE_BEAUTY_PARAM';
// 更新是否录制直播
export const UPDATE_RECORD_LIVE = 'UPDATE_RECORD_LIVE';
// 更新是否采集视频状态
export const UPDATE_VIDEO_STATE = 'UPDATE_VIDEO_STATE';
// 更新是否采集视频状态
export const UPDATE_AUDIO_STATE = 'UPDATE_AUDIO_STATE';
// 更新音量大小
export const UPDATE_AUDIO_LEVEL = 'UPDATE_AUDIO_LEVEL';
// 更新上行网络质量登记
export const UPDATE_UPLINK_NETWORK_LEVEL = 'UPDATE_UPLINK_NETWORK_LEVEL';

// 更新memberList
export const UPDATE_MEMBER_LIST = 'UPDATE_MEMBER_LIST';
// 更新totalSeconds
export const UPDATE_TOTAL_SECONDS = 'UPDATE_TOTAL_SECONDS';

// 更新time
export const UPDATE_TIME = 'UPDATE_TIME';

// 更新所有的远程流
export const UPDATE_ALL_REMOTE_LIST = 'UPDATE_ALL_REMOTE_LIST';
// 更新远程流
export const UPDATE_REMOTE_LIST = 'UPDATE_REMOTE_LIST';
// 更新人员连麦列表
export const UPDATE_USER_LINK_LIST = 'UPDATE_USER_LINK_LIST';
// 更新清晰度配置
export const UPDATE_CLARITY_CONFIG = 'UPDATE_CLARITY_CONFIG';
// 更新是否混流
export const UPDATE_IS_MIXTRANSCODE = 'UPDATE_IS_MIXTRANSCODE';

// 更新重新混流
export const UPDATE_AFRES_MIXTRANSCODE = 'UPDATE_AFRES_MIXTRANSCODE';
// 更新分享流文件
export const UPDATE_SCREEN_PROFILE = 'UPDATE_SCREEN_PROFILE';
